var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "childRef", staticClass: "container reportDetail_reportItem" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _vm.canPublish
            ? _c("el-checkbox", {
                attrs: { label: _vm.$t("storeFeedback.report.publish") },
                model: {
                  value: _vm.publishFlag,
                  callback: function ($$v) {
                    _vm.publishFlag = $$v
                  },
                  expression: "publishFlag",
                },
              })
            : _vm._e(),
          _vm.fcQuestionRemarksEdit
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveFcRemark } },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              )
            : _vm._e(),
          _vm.value.canEdit && _vm.status != "suspend"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.reportsSave,
                      expression: "Feedback-reportsSave",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
              )
            : _vm._e(),
          _vm.value.canChangeLevel && _vm.status != "suspend"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.changeReportAfterApprove,
                      expression: "Feedback-changeReportAfterApprove",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.changeLevel },
                },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              )
            : _vm._e(),
          _vm.value.canEdit && _vm.status != "suspend"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.Feedback - _vm.reportsSave,
                      expression: "Feedback-reportsSave",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("reportForm")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.submit")) + " ")]
              )
            : _vm._e(),
          _vm.value.canEdit && _vm.status != "suspend"
            ? [
                _c("br"),
                _c(
                  "label",
                  {
                    staticStyle: {
                      "font-size": "12px",
                      color: "#F56C6C",
                      clear: "both",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "reportForm",
          attrs: {
            model: _vm.feedbackReport,
            "label-position": "right",
            inline: "",
            "label-width": "255px",
            rules: _vm.feedbackReportRules,
          },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("storeFeedback.report.feedbackNo") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.feedbackHead.feedbackNo,
                      disabled: "",
                      clearable: "",
                    },
                  }),
                ],
                1
              ),
              !_vm.value.canEdit
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("storeFeedback.feedbackStatus"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm.currentNodeName,
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("storeFeedback.report.reportNo") } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.feedbackReport.reportNo,
                      placeholder: "保存后生成",
                      disabled: "",
                      clearable: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.reportType"),
                    prop: "reportType",
                  },
                },
                [
                  _c("IcSelect", {
                    attrs: {
                      table: "TT_FEEDBACK_REPORT",
                      field: "REPORT_TYPE",
                      clearable: "",
                      disabled:
                        !_vm.feedbackReport.canEdit || _vm.status == "suspend",
                    },
                    model: {
                      value: _vm.feedbackReport.reportType,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "reportType", $$v)
                      },
                      expression: "feedbackReport.reportType",
                    },
                  }),
                ],
                1
              ),
              !_vm.value.canEdit
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "storeFeedback.report.haveInterrogativeCommunication"
                          ),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm._f("ic")(
                              !!_vm.feedbackReport.answer ? "Y" : "N",
                              "COMMON",
                              "YES_NO"
                            ),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              !_vm.value.canEdit
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "storeFeedback.report.doubtCommunicationStatus"
                          ),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: _vm._f("ic")(
                              _vm.feedbackReport.answerStatus,
                              "TT_FEEDBACK_REPORT",
                              "QUESTION_STATUS"
                            ),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.isMCD
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("storeFeedback.report.storeTime"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: (
                              _vm.feedbackReport.storeOperateTime / 1
                            ).toFixed(2),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.isMCD || _vm.isFBC
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("storeFeedback.report.fbcOperateTime"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: (
                              _vm.feedbackReport.fbcOperateTime / 1
                            ).toFixed(2),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.isMCD
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("storeFeedback.report.mcdOperateTime"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: (
                              _vm.feedbackReport.mcdOperateTime / 1
                            ).toFixed(2),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.isSUP || _vm.isMCD
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("storeFeedback.supplierCostTime"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            value: (
                              _vm.feedbackReport.supOperateTime / 1
                            ).toFixed(2),
                            disabled: "",
                            clearable: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              !_vm.isStore
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "widthReset",
                      attrs: {
                        label: _vm.$t("storeFeedback.report.remark"),
                        prop: "reportRemark",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: "",
                          clearable: "",
                          disabled:
                            !_vm.feedbackReport.canEdit ||
                            _vm.status == "suspend",
                          maxlength: "200",
                        },
                        model: {
                          value: _vm.feedbackReport.reportRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackReport, "reportRemark", $$v)
                          },
                          expression: "feedbackReport.reportRemark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm.isStore
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.CQSAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                                prop: "cqsAnalysis",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: !_vm.feedbackReport.canAudit,
                                  clearable: "",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.cqsAnalysis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "cqsAnalysis",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.cqsAnalysis",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isStore && _vm.feedbackReport.publishRemark
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.publishAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.publishAnalysis"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: "",
                                  clearable: "",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.publishRemark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "publishRemark",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.publishRemark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-card",
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.basicInfo"))),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("storeFeedback.report.receiveDate") },
                },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm._f("dateFormatFilter")(
                        _vm.feedbackReport.receiveDate,
                        "YYYY-MM-DD"
                      ),
                      disabled: "",
                      clearable: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("storeFeedback.report.problemLevel") },
                },
                [
                  _c("ic-select", {
                    attrs: {
                      table: "TT_FEEDBACK_FIRST_CHECK",
                      field: "PROBLEM_LEVEL",
                      disabled: !_vm.feedbackReport.canChangeLevel,
                    },
                    model: {
                      value: _vm.feedbackReport.feedbackLevel,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "feedbackLevel", $$v)
                      },
                      expression: "feedbackReport.feedbackLevel",
                    },
                  }),
                ],
                1
              ),
              !_vm.isStore
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("storeFeedback.report.deadline") },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm._f("dateFormatFilter")(
                            _vm.feedbackReport.reportDeadline,
                            "YYYY-MM-DD HH:mm:ss"
                          ),
                          disabled: "",
                          clearable: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isStore
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeFeedback.report.haveRejected"),
                      },
                    },
                    [
                      _vm.feedbackReport.haveRejectedByCqs
                        ? _c("el-input", {
                            attrs: {
                              value: _vm._f("ic")(
                                _vm.feedbackReport.haveRejectedByCqs,
                                "COMMON",
                                "YES_NO"
                              ),
                              disabled: "",
                              clearable: "",
                            },
                          })
                        : _c("el-input", {
                            attrs: { value: "否", disabled: "", clearable: "" },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.canContinue"),
                    prop: "canContinue",
                  },
                },
                [
                  _c("IcSelect", {
                    attrs: {
                      table: "COMMON",
                      field: "YES_NO",
                      clearable: "",
                      disabled:
                        !_vm.feedbackReport.canEdit || _vm.status == "suspend",
                    },
                    model: {
                      value: _vm.feedbackReport.canContinue,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "canContinue", $$v)
                      },
                      expression: "feedbackReport.canContinue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.sampleHandleMethod"),
                    prop: "sampleHandleMethod",
                  },
                },
                [
                  _c("ic-select", {
                    attrs: {
                      table: "TT_FEEDBACK_REPORT",
                      field: "SAMPLE_HANDLE_METHOD",
                      clearable: "",
                      disabled:
                        !_vm.feedbackReport.canEdit || _vm.status == "suspend",
                    },
                    model: {
                      value: _vm.feedbackReport.sampleHandleMethod,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "sampleHandleMethod", $$v)
                      },
                      expression: "feedbackReport.sampleHandleMethod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.responsibleParty"),
                    prop: "responsibleParty",
                  },
                },
                [
                  _c("ic-select", {
                    attrs: {
                      "table-fields": _vm.responsiblePartyField,
                      clearable: "",
                      disabled:
                        !_vm.feedbackReport.canEdit || _vm.status == "suspend",
                    },
                    model: {
                      value: _vm.feedbackReport.responsibleParty,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "responsibleParty", $$v)
                      },
                      expression: "feedbackReport.responsibleParty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.needDebit"),
                    prop: "needDebit",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        disabled:
                          !_vm.feedbackReport.canEdit ||
                          _vm.status == "suspend",
                      },
                      on: { change: _vm.needDebitChange },
                      model: {
                        value: _vm.feedbackReport.needDebit,
                        callback: function ($$v) {
                          _vm.$set(_vm.feedbackReport, "needDebit", $$v)
                        },
                        expression: "feedbackReport.needDebit",
                      },
                    },
                    [
                      _c("el-option", { attrs: { value: "Y", label: "是" } }, [
                        _vm._v("是"),
                      ]),
                      _c("el-option", { attrs: { value: "N", label: "否" } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.debitNumber"),
                    prop: "debitNumber",
                    rules: _vm.isneedDebit
                      ? _vm.feedbackReportRules.debitNumber
                      : _vm.feedbackReportRules.debitNumber2,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      onkeyup:
                        "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                      clearable: "",
                      disabled: !_vm.feedbackReport.canEdit || !_vm.isneedDebit,
                      maxLength: "9",
                    },
                    on: { blur: _vm.debitNumberBlur },
                    model: {
                      value: _vm.feedbackReport.debitNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "debitNumber", $$v)
                      },
                      expression: "feedbackReport.debitNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.report.debitUnit"),
                    prop: "debitUnit",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", disabled: true },
                    model: {
                      value: _vm.feedbackReport.debitUnitI18n,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "debitUnitI18n", $$v)
                      },
                      expression: "feedbackReport.debitUnitI18n",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("storeFeedback.report.reportDetail"))),
                  ]),
                ]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                            prop: "reportDetail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "10000",
                              autosize: "",
                              clearable: "",
                              disabled:
                                !_vm.feedbackReport.canEdit ||
                                _vm.status == "suspend",
                            },
                            model: {
                              value: _vm.feedbackReport.reportDetail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.feedbackReport,
                                  "reportDetail",
                                  $$v
                                )
                              },
                              expression: "feedbackReport.reportDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.DocAttachment"),
                            prop: "reportDetailDoc",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.reportDetailDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.value.canEdit
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.feedbackReport
                                                          .reportDetailDoc
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1750758934
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit && _vm.status != "suspend"
                            ? _c(
                                "el-upload",
                                {
                                  ref: "reportDetailDoc",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.reportDetailDocUpload,
                                    multiple: "",
                                    "on-remove": _vm.reportDetailDocRemove,
                                    "before-upload":
                                      _vm.reportDetailBeforeUpload,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.PicAttachment"),
                            prop: "reportDetailImg",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "reportDetailImg",
                              staticClass: "reportDetailImgClass",
                              class: { hide: !_vm.feedbackReport.canEdit },
                              attrs: {
                                headers: _vm.header,
                                action: _vm.fileUploadUrl,
                                disabled: !_vm.feedbackReport.canEdit,
                                "show-file-list": true,
                                "on-success": _vm.reportDetailImgUpload,
                                multiple: "",
                                "file-list": _vm.reportDetailImg,
                                "before-remove":
                                  _vm.reportDetailImgBeforeRemove,
                                "on-preview": _vm.reportDetailImgPreview,
                                "list-type": "picture-card",
                                name: "file",
                                "on-change": _vm.reportDetailImgChange,
                                "before-upload":
                                  _vm.reportDetailImgBeforeUpload,
                                accept:
                                  ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function ({ file }) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              clearable: "",
                                              disabled:
                                                !_vm.feedbackReport.canEdit,
                                              placeholder: "请输入图片描述",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.miaoahuChange(file)
                                              },
                                            },
                                            model: {
                                              value: file.docComments,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  file,
                                                  "docComments",
                                                  $$v
                                                )
                                              },
                                              expression: "file.docComments",
                                            },
                                          }),
                                          _c("img", {
                                            staticClass:
                                              "el-upload-list__item-thumbnail",
                                            attrs: { src: file.url, alt: "" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-actions",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-upload-list__item-preview",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.reportDetailImgPreview(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-zoom-in",
                                                  }),
                                                ]
                                              ),
                                              file.tmDocumentId
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "el-upload-list__item-delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadFile(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-download",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.feedbackReport.canEdit
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "el-upload-list__item-delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.reportDetailImgRemove(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-delete",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                      ],
                                      2
                                    )
                                  },
                                },
                              ]),
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          ),
                          _c(
                            "el-dialog",
                            {
                              staticClass: "enlargePhoto",
                              attrs: {
                                visible: _vm.dialogVisible,
                                "append-to-body": "",
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.dialogImageUrl,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "autoWidth" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("storeFeedback.report.treatment"))),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.description"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: "",
                              clearable: "",
                              disabled:
                                !_vm.feedbackReport.canEdit ||
                                _vm.status == "suspend",
                              maxlength: "1000",
                            },
                            model: {
                              value: _vm.feedbackReport.treatment,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackReport, "treatment", $$v)
                              },
                              expression: "feedbackReport.treatment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "15%",
                            label: _vm.$t("storeFeedback.report.attachment"),
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticClass: "tableFile",
                              attrs: {
                                data: _vm.feedbackReport.treatmentDoc,
                                border: "",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  sortable: "",
                                  prop: "documentName",
                                  label: _vm.$t("common.file"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.downloadFile(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.documentName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm.value.canEdit
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "tmDocumentId",
                                      "min-width": "130px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.deleteFile(
                                                        scope.row.tmDocumentId,
                                                        scope.$index,
                                                        _vm.feedbackReport
                                                          .treatmentDoc
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("common.del"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1504342029
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.feedbackReport.canEdit && _vm.status != "suspend"
                            ? _c(
                                "el-upload",
                                {
                                  ref: "treatmentDoc",
                                  attrs: {
                                    action: "upload",
                                    "http-request": _vm.treatmentDocUpload,
                                    multiple: "",
                                    "before-upload": _vm.treatmentBeforeUpload,
                                    "on-remove": _vm.treatmentDocRemove,
                                    "show-file-list": "false",
                                    name: "file",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "trigger",
                                        size: "small",
                                        type: "primary",
                                      },
                                      slot: "trigger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.selectFile"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isStore
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.supplierAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                                prop: "supplierAnalysis",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  clearable: "",
                                  disabled:
                                    !_vm.feedbackReport.canEdit ||
                                    _vm.status == "suspend",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.supplierAnalysis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "supplierAnalysis",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.supplierAnalysis",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !(_vm.value.canEdit || _vm.isFBC || _vm.isStore)
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.CQSAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                                prop: "cqsAnalysis",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: !_vm.feedbackReport.canAudit,
                                  clearable: "",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.cqsAnalysis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "cqsAnalysis",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.cqsAnalysis",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isFBC
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.FBCAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: !_vm.feedbackReport.canAudit,
                                  clearable: "",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.cqsAnalysis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "cqsAnalysis",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.cqsAnalysis",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isStore && _vm.feedbackReport.publishRemark
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.publishAnalysis"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.publishAnalysis"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: "",
                                  clearable: "",
                                  maxlength: "1000",
                                },
                                model: {
                                  value: _vm.feedbackReport.publishRemark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "publishRemark",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.publishRemark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          (_vm.feedbackReport.feedbackLevel == "A" ||
            _vm.feedbackReport.feedbackLevel == "B") &&
          _vm.feedbackReport.auditorSignId
            ? _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("storeFeedback.report.sign"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-image", {
                            staticStyle: { width: "200px", height: "100px" },
                            attrs: {
                              fit: "contain",
                              src: _vm.HandleUrl(
                                _vm.feedbackReport.auditorSignId
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isMCD || _vm.isFBC || (_vm.isSUP && !_vm.isNew)
            ? _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("common.approvalLog")))])]
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.feedbackReport.logs,
                        align: "center",
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "createDate",
                          label: _vm.$t("common.OperationTime"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormatFilter")(
                                        scope.row.createDate,
                                        "YYYY-MM-DD HH:mm:ss"
                                      )
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3398165263
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operatorName",
                          label: _vm.$t("common.OperatorName"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "action",
                          label: _vm.$t("common.PedagogicalOperation"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "comments",
                          label: _vm.$t("common.opinion"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.comments))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1058520930
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            model: _vm.feedbackReport,
            "label-position": "right",
            "label-width": "30%",
          },
        },
        [
          (_vm.feedbackReport.question != null && _vm.isStore) ||
          (!_vm.isSUP && !_vm.isStore)
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("storeFeedback.report.questionOfStore"))
                    ),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.feedbackReport.question,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackReport,
                                      "question",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackReport.question",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.attachment"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "tableFile",
                                  attrs: {
                                    data: _vm.feedbackReport.questionDoc,
                                    border: "",
                                    "highlight-current-row": "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "documentName",
                                      label: _vm.$t("common.file"),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.downloadFile(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.documentName
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1787077931
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          (_vm.feedbackReport.answer != null && _vm.isStore) ||
          (!_vm.isSUP && !_vm.isStore)
            ? _c(
                "el-card",
                { staticClass: "autoWidth" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("storeFeedback.report.answerOfFBC"))
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.description"
                                ),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "1000",
                                  autosize: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.feedbackReport.answer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.feedbackReport, "answer", $$v)
                                  },
                                  expression: "feedbackReport.answer",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "15%",
                                label: _vm.$t(
                                  "storeFeedback.report.attachment"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "tableFile",
                                  attrs: {
                                    data: _vm.feedbackReport.answerDoc,
                                    border: "",
                                    "highlight-current-row": "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      sortable: "",
                                      prop: "documentName",
                                      label: _vm.$t("common.file"),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-link",
                                                {
                                                  attrs: { type: "primary" },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.downloadFile(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.documentName
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1787077931
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.isSUP && !_vm.isStore
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    "label-width": "15%",
                                    label: _vm.$t(
                                      "storeFeedback.report.fcQuestionRemarks"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      autosize: "",
                                      disabled: !_vm.fcQuestionRemarksEdit,
                                    },
                                    model: {
                                      value:
                                        _vm.feedbackReport.fcQuestionRemarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.feedbackReport,
                                          "fcQuestionRemarks",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "feedbackReport.fcQuestionRemarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSUP && !_vm.isStore
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "widthReset",
                                  attrs: {
                                    "label-width": "15%",
                                    label: _vm.$t(
                                      "storeFeedback.report.fcAnnex"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.fcQuestionRemarksEdit,
                                          expression: "fcQuestionRemarksEdit",
                                        },
                                      ],
                                      ref: "upload",
                                      staticStyle: { float: "left" },
                                      attrs: {
                                        action: "upload",
                                        "http-request": _vm.uploadConfirm,
                                        "show-file-list": false,
                                        multiple: "",
                                        name: "file",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            slot: "trigger",
                                            size: "small",
                                            type: "primary",
                                          },
                                          slot: "trigger",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.selectFile"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "table",
                                      attrs: {
                                        data: _vm.fcFileList,
                                        border: "",
                                        "highlight-current-row": "",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "",
                                          prop: "documentName",
                                          label: _vm.$t("common.file"),
                                          "min-width": "130px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-link",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadFile(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.documentName
                                                        ) + " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1787077931
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "",
                                          prop: "userName",
                                          label: _vm.$t("common.createBy"),
                                          "min-width": "130px",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "",
                                          prop: "createDate",
                                          label: _vm.$t("common.createDate"),
                                          "min-width": "130px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateFormatFilter"
                                                        )(
                                                          scope.row.createDate,
                                                          "YYYY-MM-DD HH:mm"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          316268277
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "tmDocumentId",
                                          "min-width": "130px",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-link",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.fcQuestionRemarksEdit,
                                                          expression:
                                                            "fcQuestionRemarksEdit",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.deleteFcFile(
                                                            scope.row
                                                              .tmDocumentId,
                                                            scope.$index,
                                                            _vm.fcFileList
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("common.del")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          701955061
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.feedbackReport.question && _vm.status != "suspend" && _vm.isStore
        ? _c(
            "el-tooltip",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.Feedback - _vm.reportsQuestion,
                  expression: "Feedback-reportsQuestion",
                },
              ],
              staticClass: "item",
              attrs: {
                effect: "dark",
                content:
                  "如您对问题报告还有其它意见，请在5天内点击疑问沟通反馈",
                placement: "top-start",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showQuestionFun },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("storeFeedback.report.doubtCommunication"))
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("storeFeedback.report.doubtCommunication"),
            visible: _vm.questionDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.questionDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "questionForm",
              attrs: {
                model: _vm.feedbackReport,
                "label-position": "right",
                "label-width": "20%",
                rules: _vm.questionFormRules,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "15%",
                    label: _vm.$t("storeFeedback.report.description"),
                    prop: "question",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", autosize: "" },
                    model: {
                      value: _vm.feedbackReport.question,
                      callback: function ($$v) {
                        _vm.$set(_vm.feedbackReport, "question", $$v)
                      },
                      expression: "feedbackReport.question",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "15%",
                    label: _vm.$t("storeFeedback.report.attachment"),
                    prop: "questionDoc",
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "questionDoc",
                      attrs: {
                        action: "upload",
                        "http-request": _vm.questionDocUpload,
                        multiple: "",
                        "on-remove": _vm.questionDocRemove,
                        "show-file-list": "false",
                        name: "file",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.questionDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.questionSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }